import { render, staticRenderFns } from "./gDeductionRecord.vue?vue&type=template&id=576bc5e8&scoped=true"
import script from "./gDeductionRecord.vue?vue&type=script&lang=js"
export * from "./gDeductionRecord.vue?vue&type=script&lang=js"
import style0 from "./gDeductionRecord.vue?vue&type=style&index=0&id=576bc5e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576bc5e8",
  null
  
)

export default component.exports